import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["isValid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { getClientAppData, hasRole } from "@/js/http/auth";
import { listTerms, purchaseOrder } from "@/js/lists.ts";
import { formatPrice, getImplantedCurrencies } from "@/js/currency/currencies.js";
import { getErrorData, handleErrorData, ERROR_DATA, hackReactivityForm } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import Address from "@/components/address/Address.vue";
import PurchaseOrderItemsTable from "@/components/purchase-orders/PurchaseOrderItemsTable.vue";
import WarehouseSelectComponent from "@/components/warehouse/WarehouseSelectComponent.vue";
import SupplierSelectComponent from "@/components/supplier-prices/SupplierSelectComponent.vue";
import PurchaseOrderFormSaveAndSendDrawer from "@/components/purchase-orders/PurchaseOrderFormSaveAndSendDrawer.vue";
import PurchaseOrderAttachedFilesDrawer from "@/components/purchase-orders/PurchaseOrderAttachedFilesDrawer.vue";
import SendMailModal from "@/components/mail/SendMailModal.vue";
import SplitButton from "@/components/common/SplitButton.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    Address: Address,
    Confirm: Confirm,
    SupplierSelectComponent: SupplierSelectComponent,
    PurchaseOrderItemsTable: PurchaseOrderItemsTable,
    WarehouseSelectComponent: WarehouseSelectComponent,
    PurchaseOrderFormSaveAndSendDrawer: PurchaseOrderFormSaveAndSendDrawer,
    PurchaseOrderAttachedFilesDrawer: PurchaseOrderAttachedFilesDrawer,
    SendMailModal: SendMailModal,
    SplitButton: SplitButton,
    ErrorModal: ErrorModal
  },
  props: {
    id: {
      type: [String, Number]
    },
    loggedUserData: Object
  },
  data: function data(_this) {
    return {
      clientAppData: null,
      purchaseOrder: purchaseOrder,
      isLoading: true,
      isEditing: false,
      isSavingDraft: false,
      isSavingRegular: false,
      isSavingAndSending: false,
      isSavingComment: false,
      isSavingDeliveryDate: false,
      isCreatingStocks: false,
      isSavingPaymentStatus: false,
      isSavingBillDate: false,
      isSavingPaymentDate: false,
      isSavingTerms: false,
      isSavingPaymentMethod: false,
      isDownloadingPoFile: false,
      isMarkingAsNotified: false,
      sendMailModalShown: false,
      purchaseOrderFormSaveAndSendDrawerShown: false,
      isReadOnly: false,
      isDraft: true,
      suppliers: [],
      warehouses: [],
      wines: [],
      itemOptions: [],
      isLoadingWines: false,
      countries: [],
      states: [],
      implantedMarketCountries: [],
      form: {
        id: null,
        isAllocation: false,
        commentary: null,
        valid: false,
        isSupplierNotifSended: false,
        supplierNotifDate: null,
        isAutoGenerate: false,
        isCloseConsignmentStocks: true,
        supplierId: null,
        producerId: null,
        producerAlternateStorageAddressId: null,
        warehouseId: null,
        reference: null,
        date: new Date().toISOString().substr(0, 10),
        expectedDeliveryDate: new Date().toISOString().substr(0, 10),
        expectedDate: null,
        actualDeliveryDate: null,
        billDate: null,
        paymentDate: null,
        termsId: 1,
        items: [],
        receiptStatus: null,
        paymentStatus: null,
        isPreArrivalStockCreated: false
      },
      defaultForm: null,
      // Initialized in created().

      dateMenu: null,
      expectedDateMenu: null,
      actualDeliveryDateMenu: null,
      billDateMenu: null,
      paymentDateMenu: null,
      dbPurchaseOrder: null,
      currencies: getImplantedCurrencies(),
      exportingPdf: {
        isPending: false,
        cancellationToken: null,
        isConfiguring: false,
        form: {
          currency: "EUR",
          currencyRate: null,
          docTitle: ""
        }
      },
      checkingPosInProgressSupplier: {
        isPending: false,
        results: []
      },
      listPaymentMethods: Object.entries(purchaseOrder.paymentMethod).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (isNaN(key)) return acc;
        return [].concat(_toConsumableArray(acc), [{
          value: +key,
          label: value.text
        }]);
      }, []),
      rules: formRules,
      listTerms: listTerms,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isCreatingNewPo: function isCreatingNewPo() {
      return this.form.id <= 0;
    },
    isSaving: function isSaving() {
      return this.isSavingDraft || this.isSavingAndSending || this.isSavingRegular || this.isCreatingStocks;
    },
    isSupplierWinery: function isSupplierWinery() {
      var _this$suppliers,
        _this2 = this;
      return !!((_this$suppliers = this.suppliers) !== null && _this$suppliers !== void 0 && (_this$suppliers = _this$suppliers.find(function (x) {
        return x.id == _this2.form.supplierId;
      })) !== null && _this$suppliers !== void 0 && _this$suppliers.producerId);
    },
    canBypassFillOrders: function canBypassFillOrders() {
      return hasRole(process.env.VUE_APP_ROLES_BYPASS_PURCHASE_ORDERS_FILL_ORDERS);
    },
    hasFillOrderIssues: function hasFillOrderIssues() {
      var _this3 = this;
      if (this.form.isAllocation) return false;
      var items = this.form.items || [];
      if (!items.length) return false;

      // If there are unsaved changes on items/fill-orders, keep disabled to avoid mismatch
      var hasUnsavedItems = function () {
        if (!_this3.dbPurchaseOrder || !_this3.dbPurchaseOrder.items) return false;
        var normalize = function normalize(list) {
          return (list || []).map(function (it) {
            return {
              id_wine: it.id_wine || it.wineId,
              quantity: Number(it.quantity) || 0,
              qfo: (it.quantitiesForOrders || []).map(function (q) {
                return {
                  orderId: q.id_order || q.orderId,
                  quantity: Number(q.quantity) || 0
                };
              })
            };
          });
        };
        var normCurrent = normalize(items);
        var normSaved = normalize(_this3.dbPurchaseOrder.items);
        var serialize = function serialize(arr) {
          return JSON.stringify(arr.map(function (it) {
            return {
              id_wine: it.id_wine,
              quantity: it.quantity,
              qfo: _toConsumableArray(it.qfo).sort(function (a, b) {
                return (a.orderId || 0) - (b.orderId || 0);
              })
            };
          }).sort(function (a, b) {
            return (a.id_wine || 0) - (b.id_wine || 0);
          }));
        };
        return serialize(normCurrent) !== serialize(normSaved);
      }();
      if (hasUnsavedItems) return true;
      var allFullyAllocated = items.every(function (item) {
        var required = Number(item.quantity) || 0;
        var allocated = (item.quantitiesForOrders || []).reduce(function (acc, x) {
          return acc + (Number(x.quantity) || 0);
        }, 0);
        return required > 0 ? allocated >= required : true;
      });
      return !allFullyAllocated;
    },
    isActualDeliveryDateDisabled: function isActualDeliveryDateDisabled() {
      if (this.canBypassFillOrders) return false;
      return this.hasFillOrderIssues;
    },
    currentSupplierAddress: function currentSupplierAddress() {
      var _this$suppliers$find,
        _this4 = this;
      return this.isReadOnly ? this.form.supplierAddress : (_this$suppliers$find = this.suppliers.find(function (x) {
        return x.id === _this4.form.supplierId;
      })) === null || _this$suppliers$find === void 0 ? void 0 : _this$suppliers$find.address;
    },
    currentWarehouse: function currentWarehouse() {
      var _this5 = this;
      return this.warehouses.find(function (x) {
        return x.id_warehouse === _this5.form.warehouseId;
      }) || {
        address: {
          country: {}
        }
      };
    },
    currentWarehouseAddress: function currentWarehouseAddress() {
      return this.currentWarehouse.address;
    },
    hasFillingOrders: function hasFillingOrders() {
      var _this$form$items;
      return (_this$form$items = this.form.items) === null || _this$form$items === void 0 ? void 0 : _this$form$items.some(function (x) {
        var _x$quantitiesForOrder;
        return ((_x$quantitiesForOrder = x.quantitiesForOrders) === null || _x$quantitiesForOrder === void 0 ? void 0 : _x$quantitiesForOrder.length) > 0;
      });
    },
    producerStorageAddresses: function producerStorageAddresses() {
      var _this6 = this;
      if (!this.isSupplierWinery) {
        return [];
      } else {
        var _this$suppliers$find2;
        return [{
          addressId: null,
          text: "Winery main address"
        }].concat(_toConsumableArray((_this$suppliers$find2 = this.suppliers.find(function (x) {
          return x.id === _this6.form.supplierId;
        })) === null || _this$suppliers$find2 === void 0 ? void 0 : _this$suppliers$find2.producerAlternateStorageAdresses.map(function (x) {
          return {
            addressId: x.address.id_address,
            text: x.name + " (" + x.address.country.printable_name + ")"
          };
        })));
      }
    },
    hasReceivedItems: function hasReceivedItems() {
      return this.form.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
    },
    isCancelled: function isCancelled() {
      return this.form.status === purchaseOrder.status.CANCELLED;
    },
    isBilled: function isBilled() {
      return this.form.paymentStatus === purchaseOrder.paymentStatus.BILLED;
    },
    isPaid: function isPaid() {
      return this.form.paymentStatus === purchaseOrder.paymentStatus.PAID;
    },
    splitButtonMainAction: function splitButtonMainAction() {
      var _this7 = this;
      if (this.isDraft) {
        return {
          label: "Save PO as draft",
          click: this.saveAsDraft,
          loading: this.isSavingDraft,
          disabled: !this.form.valid || this.isLoadingWines || this.isSaving,
          icon: "fas fa-file"
        };
      }
      if (!this.isReadOnly && !this.isDraft) {
        return {
          label: "Save PO",
          click: function click() {
            return _this7.save(false);
          },
          loading: this.isSavingRegular,
          disabled: !this.form.valid || this.isLoadingWines || this.isSaving || !this.form.items.length,
          icon: "fas fa-save"
        };
      }
      return {
        label: "Default",
        click: function click() {},
        loading: false,
        disabled: true,
        icon: "fas fa-question"
      };
    },
    SplitButtonDropdownActions: function SplitButtonDropdownActions() {
      var actions = [];
      if (!this.isReadOnly && !this.form.isStoredAtSupplier) {
        actions.push({
          label: "Save PO & send",
          click: this.openSaveAndSendDrawer,
          loading: this.isSavingAndSending,
          disabled: !this.form.valid || this.isLoadingWines || this.isSaving || !this.form.items.length,
          icon: "fas fa-envelope-open"
        });
      }
      if (!this.isReadOnly && this.form.isStoredAtSupplier) {
        actions.push({
          label: "Create stocks",
          click: this.confirmCreateDirectStocks,
          loading: this.isCreatingStocks,
          disabled: !this.form.valid || this.isLoadingWines || this.isSaving || !this.form.items.length,
          icon: "fas fa-boxes"
        });
      }
      return actions;
    }
  },
  created: function created() {
    var _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var id;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this8.clientAppData = getClientAppData(_this8);
            id = _this8.id;
            _this8.isEditing = !!id;
            _this8.defaultForm = _objectSpread({}, _this8.form);
            _context.next = 6;
            return Promise.all([_this8.fetchSuppliers(), _this8.fetchWarehouses(), _this8.fetchCountries(), id ? _this8.fetchPurchaseOrder(id) : Promise.resolve(), !id ? _this8.fetchLastSequenceNumber() : Promise.resolve()]);
          case 6:
            if (!id) {
              _context.next = 11;
              break;
            }
            _context.next = 9;
            return _this8.fetchWines();
          case 9:
            _context.next = 11;
            return _this8.fetchPurchaseOrder(id);
          case 11:
            if (_this8.form.items) {
              _this8.form.items = _this8.form.items.map(function (i) {
                return _objectSpread(_objectSpread({}, i), {}, {
                  image: _toConsumableArray(_this8.itemOptions).filter(function (w) {
                    return w.wineId === i.wineId;
                  }).map(function (x) {
                    return x.image;
                  }).shift()
                });
              });
            }
            if (_this8.form.supplierId) {
              _this8.setProducerIdFromSelectedSupplier();
            }
            _this8.isLoading = false;
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    formatPrice: formatPrice,
    mapFrom: function mapFrom(data) {
      var _this9 = this,
        _data$producerAlterna;
      var getAccountancyCode = function getAccountancyCode(x) {
        var wine = _this9.itemOptions.find(function (i) {
          return i.wineId === x.wineId;
        });
        return wine ? wine.accountancyCode : "";
      };
      data.producerAlternateStorageAddressId = ((_data$producerAlterna = data.producerAlternateStorageAddress) === null || _data$producerAlterna === void 0 || (_data$producerAlterna = _data$producerAlterna.address) === null || _data$producerAlterna === void 0 ? void 0 : _data$producerAlterna.id_address) || null;
      delete data.producerAlternateStorageAdress;
      return _objectSpread(_objectSpread({}, data), {}, {
        termsId: data.terms,
        items: data.items ? data.items.map(function (x) {
          return _objectSpread(_objectSpread({}, x), {}, {
            skuSuffix: String.diff(x.sku, getAccountancyCode(x)),
            accountancyCode: getAccountancyCode(x)
          });
        }) : [],
        date: new Date(data.creationDate).formatForDatePickerDays(),
        expectedDeliveryDate: new Date(data.expectedDeliveryDate).formatForDatePickerDays(),
        actualDeliveryDate: data.actualDeliveryDate ? new Date(data.actualDeliveryDate).formatForDatePickerDays() : null,
        billDate: data.billDate ? new Date(data.billDate).formatForDatePickerDays() : null,
        paymentDate: data.paymentDate ? new Date(data.paymentDate).formatForDatePickerDays() : null
      });
    },
    mapTo: function mapTo(form) {
      return {
        id: form.id,
        isDraft: form.isDraft,
        isAllocation: form.isAllocation,
        isAutoGenerate: form.isAutoGenerate,
        isSupplierNotifSended: form.isSupplierNotifSended,
        commentary: form.commentary,
        isStoredAtSupplier: form.isStoredAtSupplier,
        isCloseConsignmentStocks: form.isCloseConsignmentStocks,
        reference: form.reference,
        creationDate: form.date,
        expectedDeliveryDate: form.expectedDeliveryDate,
        actualDeliveryDate: form.actualDeliveryDate,
        billDate: form.billDate,
        paymentDate: form.paymentDate,
        terms: form.termsId,
        supplierId: form.supplierId,
        producerAlternateStorageAddressId: form.producerAlternateStorageAddressId,
        warehouseId: form.warehouseId,
        items: form.items,
        mustBeSent: form.mustBeSent
      };
    },
    saveItems: function saveItems(items) {
      this.form.items = _toConsumableArray(items);
    },
    openAttachedFilesDrawer: function openAttachedFilesDrawer() {
      this.$refs.PurchaseOrderAttachedFilesDrawer.openDrawer();
    },
    confirmDownloadPoFile: function confirmDownloadPoFile() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this10.$refs.confirm.open("Download file", "If there is any change not saved yet, they won't be applied on the file. Continue ?");
            case 2:
              isConfirmed = _context2.sent;
              if (isConfirmed) _this10.downloadPoFile();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    downloadPoFile: function downloadPoFile() {
      var _this = this;
      _this.isDownloadingPoFile = true;
      request("/v1/purchase-orders/".concat(_this.id, "/files/po"), "get", null, true, "api", null).then(function (response) {
        _this.openUrl(response.data.url);
      }).catch(function (e) {
        _this.$toasted.show("Unable to download file.", {
          type: "error"
        });
      }).finally(function () {
        _this.isDownloadingPoFile = false;
      });
    },
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    returnToList: function returnToList() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isConfirmed = _this11.isReadOnly;
              if (_this11.isReadOnly) {
                _context3.next = 5;
                break;
              }
              _context3.next = 4;
              return _this11.$refs.confirm.open("Return to list", "Are you sure you want to return to the purchase order list ? Your unsaved changes will be lost.");
            case 4:
              isConfirmed = _context3.sent;
            case 5:
              if (isConfirmed) _this11.$router.push({
                name: "adminStockList",
                query: {
                  tab: "purchaseOrder"
                }
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    cancelPurchaseOrder: function cancelPurchaseOrder() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this12.$refs.confirm.open("Cancel", "Are you sure you want to cancel this purchase order?", {
                color: "red"
              });
            case 2:
              confirmed = _context4.sent;
              if (!confirmed) {
                _context4.next = 11;
                break;
              }
              _this12.$EventBus.$emit("loading", true);
              _this = _this12;
              _context4.next = 8;
              return request("/v1/purchase-orders/".concat(_this12.form.id), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to cancel this purchase order.", {
                  type: "error"
                });
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 8:
              _this12.$EventBus.$emit("loading", false);
              _this12.drawer = false;
              _this12.fetchPurchaseOrder(_this12.form.id);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    saveAsDraft: function saveAsDraft() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, _this, response, newPoId;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this13.isSavingDraft = true;
              data = _this13.mapTo(_objectSpread(_objectSpread({}, _this13.form), {}, {
                isDraft: true
              }));
              _this = _this13;
              _context5.next = 5;
              return request("/v1/purchase-orders", _this13.isCreatingNewPo ? "post" : "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the purchase order");
                handleErrorData(_this, errorData);
                _this.isSavingDraft = false;
                throw e;
              });
            case 5:
              response = _context5.sent;
              _this13.$toasted.show("Draft saved successfully.", {
                type: "success"
              });
              if (!_this13.isCreatingNewPo) {
                _context5.next = 14;
                break;
              }
              newPoId = +response.data.value;
              _this13.$router.replace({
                name: "adminEditPurchaseOrder",
                params: {
                  id: newPoId
                }
              });
              _context5.next = 12;
              return _this13.fetchPurchaseOrder(newPoId);
            case 12:
              _context5.next = 16;
              break;
            case 14:
              _context5.next = 16;
              return _this13.fetchPurchaseOrder(_this13.form.id);
            case 16:
              _this13.$refs.purchaseOrderItemsTable.refreshItemList();
              _this13.isSavingDraft = false;
            case 18:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    save: function save(silentSave) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, _this, response, newPoId;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this14.isSavingRegular = true;
              data = _this14.mapTo(_objectSpread({}, _this14.form));
              _this = _this14;
              _context6.next = 5;
              return request("/v1/purchase-orders", _this14.isCreatingNewPo ? "post" : "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the purchase order");
                handleErrorData(_this, errorData);
                _this.isSavingRegular = false;
                throw e;
              });
            case 5:
              response = _context6.sent;
              if (!silentSave) _this14.$toasted.show("Saved.", {
                type: "success"
              });
              if (!_this14.isCreatingNewPo) {
                _context6.next = 14;
                break;
              }
              newPoId = +response.data.value;
              _this14.$router.replace({
                name: "adminEditPurchaseOrder",
                params: {
                  id: newPoId
                }
              });
              _context6.next = 12;
              return _this14.fetchPurchaseOrder(newPoId);
            case 12:
              _context6.next = 16;
              break;
            case 14:
              _context6.next = 16;
              return _this14.fetchPurchaseOrder(_this14.form.id);
            case 16:
              _this14.$refs.purchaseOrderItemsTable.refreshItemList();
              _this14.isSavingRegular = false;
            case 18:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    openSaveAndSendDrawer: function openSaveAndSendDrawer() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this15.save(true);
            case 2:
              _this15.purchaseOrderFormSaveAndSendDrawerShown = true;
              _this15.$nextTick(function () {
                _this15.$refs.saveAndSendDrawer.open();
              });
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    closeSaveAndSendDrawer: function closeSaveAndSendDrawer() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this16.$nextTick(function () {
                _this16.purchaseOrderFormSaveAndSendDrawerShown = false;
              });
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    saveAndSend: function saveAndSend(response) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var newPoId;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!_this17.isCreatingNewPo) {
                _context9.next = 7;
                break;
              }
              newPoId = +response.data.value;
              _this17.$router.replace({
                name: "adminEditPurchaseOrder",
                params: {
                  id: newPoId
                }
              });
              _context9.next = 5;
              return _this17.fetchPurchaseOrder(newPoId);
            case 5:
              _context9.next = 9;
              break;
            case 7:
              _context9.next = 9;
              return _this17.fetchPurchaseOrder(_this17.form.id);
            case 9:
              _this17.$refs.purchaseOrderItemsTable.refreshItemList();
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    //Not used anymore, to create allocations storedAtSupplier
    confirmCreateDirectStocks: function confirmCreateDirectStocks() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this18.$refs.confirm.open("Create stocks", "Are you sure you want to create stocks of this purchase order ? You will not be able to change this purchase order after that.");
            case 2:
              isConfirmed = _context10.sent;
              if (isConfirmed) {
                _this18.createDirectStocks();
              }
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    createDirectStocks: function createDirectStocks() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _newPoId;
        var newPoId, data, _this, response, entityId;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              newPoId = null;
              _this19.isCreatingStocks = true;
              data = _this19.mapTo(_objectSpread({}, _this19.form));
              _this = _this19;
              _context11.next = 6;
              return request("/v1/purchase-orders", _this19.isCreatingNewPo ? "post" : "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the purchase order");
                handleErrorData(_this, errorData);
                _this.isCreatingStocks = false;
                throw e;
              });
            case 6:
              response = _context11.sent;
              if (_this19.isCreatingNewPo) {
                newPoId = +response.data.value;
              }
              entityId = (_newPoId = newPoId) !== null && _newPoId !== void 0 ? _newPoId : _this19.form.id;
              data = {
                ActualDeliveryDate: moment().format("YYYY-MM-DD")
              };
              _context11.next = 12;
              return request("/v1/purchase-orders/".concat(entityId, "/receipt-status/").concat(purchaseOrder.receiptStatus.RECEIVED), "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to mark as received");
                handleErrorData(_this, errorData);
              });
            case 12:
              if (newPoId > 0) {
                _this19.$router.replace({
                  name: "adminEditPurchaseOrder",
                  params: {
                    id: entityId
                  }
                });
              }
              _context11.next = 15;
              return _this19.fetchPurchaseOrder(entityId);
            case 15:
              _this19.isCreatingStocks = false;
            case 16:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    fetchCountries: function fetchCountries() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this20.isLoadingCountries = true;
              _this = _this20;
              _context12.next = 4;
              return request("/v1/countries", "post", _this.clientAppData, false, "api").catch(function (e) {
                var _e$response;
                if ((_e$response = e.response) !== null && _e$response !== void 0 && (_e$response = _e$response.data) !== null && _e$response !== void 0 && _e$response.value) _this.$toasted.show(e.response.data.value, {
                  type: "warning"
                });else _this.$toasted.show("Unable to load intended countries.", {
                  type: "error"
                });
                _this.isLoadingCountries = false;
                throw e;
              });
            case 4:
              response = _context12.sent;
              _this20.isLoadingCountries = false;
              _this20.implantedMarketCountries = _toConsumableArray(response.data.countries.filter(function (x) {
                return !!x.implanted_market;
              }));
              _this20.countries = _toConsumableArray(response.data.countries);
              _this20.states = _toConsumableArray(response.data.states);
            case 9:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    fetchPurchaseOrder: function fetchPurchaseOrder(id) {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this, response, value;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this = _this21;
              _context13.next = 3;
              return request("/v1/purchase-orders/".concat(id), "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load current purchase order.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context13.sent;
              value = response.data.value;
              _this21.isDraft = value.status === purchaseOrder.status.DRAFT;
              _this21.isReadOnly = value.status === purchaseOrder.status.CLOSED || value.status === purchaseOrder.status.CANCELLED || value.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
              _this21.form = _objectSpread({}, _this21.mapFrom(_objectSpread({}, value)));
              _this21.form.valid = true;
              _this21.dbPurchaseOrder = _objectSpread({}, _this21.form);
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    fetchLastSequenceNumber: function fetchLastSequenceNumber() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this = _this22;
              _context14.next = 3;
              return request("/v1/purchase-orders/last-sequence-number", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load reference.", {
                  type: "error"
                });
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 3:
              response = _context14.sent;
              _this22.form.number = response.data.value;
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    fetchWarehouses: function fetchWarehouses() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this = _this23;
              _context15.next = 3;
              return request("/v1/warehouses", "post", {
                paging: null,
                allowDeleted: true
              }, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load warehouses.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context15.sent;
              _this23.warehouses = response.data.warehouses;
              _this23.warehouses.sort(function (a, b) {
                if (!a.deleted && b.deleted) return -1;
                if (a.deleted && !b.deleted) return 1;
                return 0;
              });
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    fetchSuppliers: function fetchSuppliers() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this = _this24;
              _context16.next = 3;
              return request("/v1/suppliers?includeDeleted=true", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load suppliers.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context16.sent;
              _this24.suppliers = response.data.value.map(function (supplier) {
                return _objectSpread(_objectSpread({}, supplier), {}, {
                  display_name: "".concat(supplier.name, " (").concat(supplier.producerId ? "producer" : "supplier", ")").concat(supplier.deleted ? " - Deleted" : "")
                });
              }).sort(function (a, b) {
                if (a.deleted === b.deleted) return 0;
                return a.deleted ? 1 : -1;
              });
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    fetchSuppliersWhenItemsUpdated: function fetchSuppliersWhenItemsUpdated(supplierId) {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return _this25.fetchSuppliers();
            case 2:
              _this25.changeSupplier(supplierId);
              _this25.$refs.supplierSelect.updateModel(supplierId);
            case 4:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    changeSupplier: function changeSupplier(supplierId) {
      var _this26 = this;
      this.form.supplierId = supplierId;
      if (supplierId) this.fetchWines();
      if (!this.isSupplierWinery || !this.form.isStoredAtSupplier) {
        this.form.producerAlternateStorageAddressId = null;
      } else {
        var _this$suppliers$find3;
        this.form.producerAlternateStorageAddressId = ((_this$suppliers$find3 = this.suppliers.find(function (x) {
          return x.id === _this26.form.supplierId;
        })) === null || _this$suppliers$find3 === void 0 || (_this$suppliers$find3 = _this$suppliers$find3.producerAlternateStorageAdresses) === null || _this$suppliers$find3 === void 0 || (_this$suppliers$find3 = _this$suppliers$find3.find(function (x) {
          return x.isDefaultStorage;
        })) === null || _this$suppliers$find3 === void 0 ? void 0 : _this$suppliers$find3.address.id_address) || null;
      }
      if (this.isCreatingNewPo) {
        this.checkPoInProgressSupplier();
      }
    },
    changeIsStoredAtSupplier: function changeIsStoredAtSupplier(value) {
      var _this27 = this;
      this.form.warehouseId = null;
      this.form.isCloseConsignmentStocks = false;
      if (!value) {
        this.form.producerAlternateStorageAddressId = null;
      } else {
        var _this$suppliers$find4;
        this.form.producerAlternateStorageAddressId = ((_this$suppliers$find4 = this.suppliers.find(function (x) {
          return x.id === _this27.form.supplierId;
        })) === null || _this$suppliers$find4 === void 0 || (_this$suppliers$find4 = _this$suppliers$find4.producerAlternateStorageAdresses) === null || _this$suppliers$find4 === void 0 || (_this$suppliers$find4 = _this$suppliers$find4.find(function (x) {
          return x.isDefaultStorage;
        })) === null || _this$suppliers$find4 === void 0 ? void 0 : _this$suppliers$find4.address.id_address) || null;
      }
    },
    fetchWines: function fetchWines() {
      var _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this, _this28$suppliers$fil, _this28$suppliers$fil2, wineryIdentifier, path, response;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this = _this28;
              _this28.isLoadingWines = true;
              _this28$suppliers$fil = _this28.suppliers.filter(function (x) {
                return x.id === _this28.form.supplierId;
              }).map(function (x) {
                return x.producerId;
              }), _this28$suppliers$fil2 = _slicedToArray(_this28$suppliers$fil, 1), wineryIdentifier = _this28$suppliers$fil2[0];
              path = "/v1/stock?wines=true";
              if (wineryIdentifier) {
                path += "&producerIds=".concat(wineryIdentifier);
              }
              _context18.next = 7;
              return request(path, "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load supplier's wines.", {
                  type: "error"
                });
                throw e;
              });
            case 7:
              response = _context18.sent;
              _this28.itemOptions = response.data.wines.map(function (x) {
                return {
                  wineId: x.id_wine,
                  name: x.display_name,
                  rate: x.cogs_euro_ex_vat,
                  image: x.image,
                  accountancyCode: x.accountancy_code,
                  _searchable_name: "".concat(x.display_name, " - ").concat(x.accountancy_code)
                };
              });
              if (_this28.form.supplierId) {
                _this28.setProducerIdFromSelectedSupplier();
              }
              _this28.isLoadingWines = false;
            case 11:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    changeWarehouse: function changeWarehouse(idWarehouse) {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this29.form.warehouseId = idWarehouse;
              _context19.next = 3;
              return hackReactivityForm(_this29, _this29.form, "commentary", "commentaryTextarea", "textarea");
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    fetchWarehousesWhenItemsUpdated: function fetchWarehousesWhenItemsUpdated(idWarehouse) {
      var _this30 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _this30.fetchWarehouses();
            case 2:
              _this30.changeWarehouse(idWarehouse);
              _this30.$refs.warehouseSelect.updateModel(idWarehouse);
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    setProducerIdFromSelectedSupplier: function setProducerIdFromSelectedSupplier() {
      var _this$suppliers2,
        _this31 = this;
      this.form.producerId = (_this$suppliers2 = this.suppliers) === null || _this$suppliers2 === void 0 || (_this$suppliers2 = _this$suppliers2.find(function (x) {
        return x.id === _this31.form.supplierId;
      })) === null || _this$suppliers2 === void 0 ? void 0 : _this$suppliers2.producerId;
    },
    commentChanged: function commentChanged() {
      var _this32 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!_this32.isReadOnly) {
                _context21.next = 8;
                break;
              }
              _this32.isSavingComment = true;
              data = {
                commentary: _this32.form.commentary
              };
              _this = _this32;
              _context21.next = 6;
              return request("/v1/purchase-orders/".concat(_this32.form.id, "/commentary"), "put", data, true, "api").catch(function (e) {
                var _e$response2;
                if ((_e$response2 = e.response) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.data) !== null && _e$response2 !== void 0 && _e$response2.value) _this.$toasted.show(e.response.data.value, {
                  type: "warning"
                });else _this.$toasted.show("Unable to save the commentary.", {
                  type: "error"
                });
                _this.isSavingComment = false;
                throw e;
              });
            case 6:
              _this32.isSavingComment = false;
              _this32.$toasted.show("Comment updated.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    changeActualDeliveryDate: function changeActualDeliveryDate() {
      var _this33 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!(_this33.canBypassFillOrders && _this33.hasFillOrderIssues)) {
                _context22.next = 8;
                break;
              }
              _context22.next = 3;
              return _this33.$refs.confirm.open("Force delivery date?", "Not all items are fully filled or allocated. Are you sure you want to force the actual delivery date?", {
                color: "warning"
              });
            case 3:
              confirmed = _context22.sent;
              if (confirmed) {
                _context22.next = 8;
                break;
              }
              _this33.form.actualDeliveryDate = null;
              _this33.actualDeliveryDateMenu = false;
              return _context22.abrupt("return");
            case 8:
              if (!_this33.hasReceivedItems) {
                _this33.confirmMarkAsReceived();
              } else {
                _this33.updateActualDeliveryDate();
              }
            case 9:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    confirmMarkAsReceived: function confirmMarkAsReceived() {
      var _this34 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return _this34.$refs.confirm.open("Are you sure?", "You will not be able to change this purchase order after that.", {
                color: "red"
              });
            case 2:
              confirmed = _context23.sent;
              if (confirmed) {
                _this34.markAsReceived();
              }
            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    markAsReceived: function markAsReceived() {
      var _this35 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _this35.isSavingDeliveryDate = true;
              data = {
                ActualDeliveryDate: _this35.form.actualDeliveryDate
              };
              _this = _this35;
              _context24.next = 5;
              return request("/v1/purchase-orders/".concat(_this.form.id, "/receipt-status/").concat(purchaseOrder.receiptStatus.RECEIVED), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the status as received.", {
                  type: "error"
                });
                _this.isSavingDeliveryDate = false;
                _this.actualDeliveryDateMenu = false;
                throw e;
              });
            case 5:
              _this35.isSavingDeliveryDate = false;
              _this35.actualDeliveryDateMenu = false;
              _this35.form.receiptStatus = purchaseOrder.receiptStatus.RECEIVED;
              _this35.isReadOnly = true;
              _this35.$toasted.show("Successful update of receipt status.", {
                type: "success"
              });
            case 10:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    updateActualDeliveryDate: function updateActualDeliveryDate() {
      var _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              data = {
                Date: _this36.form.actualDeliveryDate
              };
              _this = _this36;
              _context25.next = 4;
              return request("/v1/purchase-orders/".concat(_this.form.id, "/actual-delivery-date"), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the receiving date.", {
                  type: "error"
                });
                _this.actualDeliveryDateMenu = false;
                throw e;
              });
            case 4:
              _this36.actualDeliveryDateMenu = false;
              _this36.$toasted.show("Successful update.", {
                type: "success"
              });
            case 6:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    changeBillDate: function changeBillDate() {
      var _this37 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!(!_this37.isBilled && !_this37.isPaid)) {
                _context26.next = 5;
                break;
              }
              _context26.next = 3;
              return _this37.markPayment(_this37.purchaseOrder.paymentStatus.BILLED);
            case 3:
              _context26.next = 7;
              break;
            case 5:
              _context26.next = 7;
              return _this37.updateBillDate();
            case 7:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }))();
    },
    changePaymentDate: function changePaymentDate() {
      var _this38 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (_this38.isPaid) {
                _context27.next = 5;
                break;
              }
              _context27.next = 3;
              return _this38.markPayment(_this38.purchaseOrder.paymentStatus.PAID);
            case 3:
              _context27.next = 7;
              break;
            case 5:
              _context27.next = 7;
              return _this38.updatePaymentDate();
            case 7:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }))();
    },
    markPayment: function markPayment(value) {
      var _this39 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _this39.isSavingPaymentStatus = true;
              data = {
                BillDate: _this39.form.billDate,
                PaymentDate: _this39.form.paymentDate
              };
              _this = _this39;
              _context28.next = 5;
              return request("/v1/purchase-orders/".concat(_this39.form.id, "/payment-status/").concat(value), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the status.", {
                  type: "error"
                });
                _this.isSavingPaymentStatus = false;
                _this.billDateMenu = false;
                _this.paymentDateMenu = false;
                throw e;
              });
            case 5:
              _this39.isSavingPaymentStatus = false;
              _this39.billDateMenu = false;
              _this39.paymentDateMenu = false;
              _this39.form.paymentStatus = value;
              _this39.$toasted.show("Successful update.", {
                type: "success"
              });
            case 10:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    updateBillDate: function updateBillDate() {
      var _this40 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _this40.isSavingBillDate = true;
              data = {
                Date: _this40.form.billDate
              };
              _this = _this40;
              _context29.next = 5;
              return request("/v1/purchase-orders/".concat(_this40.form.id, "/bill-date"), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the bill date.", {
                  type: "error"
                });
                _this.isSavingBillDate = false;
                _this.billDateMenu = false;
                throw e;
              });
            case 5:
              _this40.isSavingBillDate = false;
              _this40.billDateMenu = false;
              _this40.$toasted.show("Successful update.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    updatePaymentDate: function updatePaymentDate() {
      var _this41 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _this41.isSavingPaymentDate = true;
              data = {
                Date: _this41.form.paymentDate
              };
              _this = _this41;
              _context30.next = 5;
              return request("/v1/purchase-orders/".concat(_this41.form.id, "/payment-date"), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the pyament date.", {
                  type: "error"
                });
                _this.isSavingPaymentDate = false;
                _this.paymentDateMenu = false;
                throw e;
              });
            case 5:
              _this41.isSavingPaymentDate = false;
              _this41.paymentDateMenu = false;
              _this41.$toasted.show("Successful update.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }))();
    },
    termsChanged: function termsChanged() {
      var _this42 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!_this42.isReadOnly) {
                _context31.next = 8;
                break;
              }
              _this42.isSavingTerms = true;
              data = {
                terms: _this42.form.termsId
              };
              _this = _this42;
              _context31.next = 6;
              return request("/v1/purchase-orders/".concat(_this42.form.id, "/payment-terms"), "put", data, true, "api").catch(function (e) {
                var _e$response3;
                if ((_e$response3 = e.response) !== null && _e$response3 !== void 0 && (_e$response3 = _e$response3.data) !== null && _e$response3 !== void 0 && _e$response3.value) _this.$toasted.show(e.response.data.value, {
                  type: "warning"
                });else _this.$toasted.show("Unable to save the terms.", {
                  type: "error"
                });
                _this.isSavingTerms = false;
                throw e;
              });
            case 6:
              _this42.isSavingTerms = false;
              _this42.$toasted.show("Terms updated.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }))();
    },
    paymentMethodChanged: function paymentMethodChanged() {
      var _this43 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _this43.isSavingPaymentMethod = true;
              data = {
                paymentMethod: _this43.form.paymentMethod
              };
              _this = _this43;
              _context32.next = 5;
              return request("/v1/purchase-orders/".concat(_this43.form.id, "/payment-method"), "put", data, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to update the payment method.", {
                  type: "error"
                });
                _this.isSavingPaymentMethod = false;
                throw e;
              });
            case 5:
              _this43.isSavingPaymentMethod = false;
              _this43.$toasted.show("Successful update.", {
                type: "success"
              });
            case 7:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }))();
    },
    openSendMailModal: function openSendMailModal() {
      var _this44 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var _this44$warehouses$fi, _this44$suppliers$fin;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _this44.sendMailModalShown = true;
              _this44.form = _objectSpread(_objectSpread({}, _this44.form), {}, {
                warehouseEmail: (_this44$warehouses$fi = _this44.warehouses.find(function (x) {
                  return x.id_warehouse === _this44.form.warehouseId;
                })) === null || _this44$warehouses$fi === void 0 ? void 0 : _this44$warehouses$fi.mail,
                supplierEmail: (_this44$suppliers$fin = _this44.suppliers.find(function (x) {
                  return x.id === _this44.form.supplierId;
                })) === null || _this44$suppliers$fin === void 0 ? void 0 : _this44$suppliers$fin.email
              });
              _this44.$nextTick(function () {
                _this44.$refs.SendMailModal.open();
              });
            case 3:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }))();
    },
    closeSendMailModal: function closeSendMailModal() {
      var _this45 = this;
      this.$nextTick(function () {
        _this45.sendMailModalShown = false;
      });
    },
    exportPdf: function exportPdf() {
      var _this46 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var _this$exportingPdf$ca;
        var _this, _this46$exportingPdf$, isValid, withoutValid, response, filename;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _this46.exportingPdf.isPending = true;
              _this = _this46;
              (_this$exportingPdf$ca = _this.exportingPdf.cancellationToken) === null || _this$exportingPdf$ca === void 0 || _this$exportingPdf$ca.cancel();
              _this.exportingPdf.cancellationToken = axios.CancelToken.source();
              _this46$exportingPdf$ = _this46.exportingPdf.form, isValid = _this46$exportingPdf$.isValid, withoutValid = _objectWithoutProperties(_this46$exportingPdf$, _excluded);
              _context35.next = 7;
              return request("/v1/purchase-orders/".concat(_this46.dbPurchaseOrder.id, "/pdf"), "post", withoutValid, true, "api", "blob", _this.exportingPdf.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee34$(_context34) {
                    while (1) switch (_context34.prev = _context34.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.exportingPdf.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to get customized PDF.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context34.stop();
                    }
                  }, _callee34);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 7:
              response = _context35.sent;
              filename = _this46.dbPurchaseOrder.number + "-currency.pdf";
              fileDownload(response.data, filename, "application/pdf");
              _this46.exportingPdf.isPending = false;
              _this46.exportingPdf.isConfiguring = false;
            case 12:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }))();
    },
    markAsNotified: function markAsNotified() {
      var _this47 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return _this47.$refs.confirm.open("Mark as notified to supplier", "Are you sure you want to mark this purchase order as notified to supplier ?");
            case 2:
              confirmed = _context36.sent;
              if (confirmed) {
                _context36.next = 5;
                break;
              }
              return _context36.abrupt("return");
            case 5:
              _this47.isMarkingAsNotified = true;
              _this = _this47;
              _context36.next = 9;
              return request("/v1/purchase-orders/".concat(_this.form.id, "/supplier-notif"), "put", null, true, "api").catch(function (e) {
                _this.isMarkingAsNotified = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to mark as notified to supplier.", true);
                handleErrorData(_this, errorData);
                _this.isMarkingAsNotified = false;
                throw e;
              });
            case 9:
              _this47.isMarkingAsNotified = false;
              _context36.next = 12;
              return _this47.fetchPurchaseOrder(_this47.form.id);
            case 12:
              _this47.$toasted.show("PO marked as notified to supplier.", {
                type: "success"
              });
            case 13:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }))();
    },
    checkPoInProgressSupplier: function checkPoInProgressSupplier() {
      var _this48 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _this48.checkingPosInProgressSupplier.results = [];
              if (!(_this48.form.supplierId > 0)) {
                _context37.next = 10;
                break;
              }
              _this = _this48;
              _this.checkingPosInProgressSupplier.isPending = true;
              data = {
                supplierIds: [_this.form.supplierId],
                typesAllowed: [purchaseOrder.status.DRAFT, purchaseOrder.status.OPEN]
              };
              _context37.next = 7;
              return request("/v1/purchase-orders/all", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to check PO of supplier", true);
                handleErrorData(_this, errorData);
                _this.checkingPosInProgressSupplier.isPending = false;
                throw e;
              });
            case 7:
              response = _context37.sent;
              _this48.checkingPosInProgressSupplier.results = _toConsumableArray(response.data.value.items);
              _this48.checkingPosInProgressSupplier.isPending = false;
            case 10:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      }))();
    },
    toPoDetails: function toPoDetails(poId) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: poId
        }
      };
    },
    filterDecimal2digitsKey: filterDecimal2digitsKey
  }
};